export default "__VITE_ASSET__Cn0EV39X__"